import { useContext } from 'react';

import { MessagesInterface } from '../../Interface/Hook/AcceptanceFeatures/MessagesInterface';
import ResultContext from '../../Context/ResultContext';
import { Result } from '../../Interface/Response/Validator/Result';

const useGetAcceptanceFeaturesMessages = (): MessagesInterface | null => {
    const result = useContext<Result | null>(ResultContext);

    if (!result) {
        return null;
    }

    return result.beoordeling.beoordelingResponse.regel.length === 0
        ? {
              judgement: result.beoordeling.beoordelingResponse.oordeel,
              message: 'Deze resultaten zijn momenteel niet beschikbaar, excuses voor het ongemak.',
          }
        : null;
};

export default useGetAcceptanceFeaturesMessages;
